'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  from { top: 0%; }\n  to { top: -100%;}\n'], ['\n  from { top: 0%; }\n  to { top: -100%;}\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  from { top: -100%; }\n  to { top: 0%;}\n'], ['\n  from { top: -100%; }\n  to { top: 0%;}\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  from { left: 0%; }\n  to { left: -100%;}\n'], ['\n  from { left: 0%; }\n  to { left: -100%;}\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  from { left: -100%; }\n  to { left: 0%; }\n'], ['\n  from { left: -100%; }\n  to { left: 0%; }\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: ', 'px;\n  height: ', 'px;\n  background-image: url(', ');\n  background-position: 0 0;\n  background-repeat: repeat;\n  animation: ', ' ', 's linear infinite;\n'], ['\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: ', 'px;\n  height: ', 'px;\n  background-image: url(', ');\n  background-position: 0 0;\n  background-repeat: repeat;\n  animation: ', ' ', 's linear infinite;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var scrollUp = (0, _styledComponents.keyframes)(_templateObject);
var scrollDown = (0, _styledComponents.keyframes)(_templateObject2);
var scrollLeft = (0, _styledComponents.keyframes)(_templateObject3);
var scrollRight = (0, _styledComponents.keyframes)(_templateObject4);

function scrollDirection(direction) {
  switch (direction) {
    case 'up':
      return scrollUp;
    case 'down':
      return scrollDown;
    case 'right':
      return scrollRight;
    case 'left':
      return scrollLeft;
    default:
      return '';
  }
}

/** @class ScrollingLayer
  * A layer sized to the stage that consists of a repeated
  * (tiled) image pattern that scrolls in the specified direction.
  * @prop {url} image - the image to repeat
  * @prop {string} direction - the direction to scroll
  * @prop {number} width - the width of the stage to cover in pixels
  * @prop {number} height - the height of the stage to cover in pixels
  */
var ScrollingLayer = _styledComponents2.default.div(_templateObject5, function (props) {
  return 2 * props.width;
}, function (props) {
  return 2 * props.height;
}, function (props) {
  return props.image;
}, function (props) {
  return scrollDirection(props.direction);
}, function (props) {
  return props.speed;
});

exports.default = ScrollingLayer;


ScrollingLayer.propTypes = {
  image: _propTypes2.default.string.isRequired,
  direction: _propTypes2.default.string.isRequired,
  width: _propTypes2.default.number.isRequired,
  height: _propTypes2.default.number.isRequired
};


//////////////////
// WEBPACK FOOTER
// ../vexpo-components/build/stage/scrolling-layer.js
// module id = 1192
// module chunks = 0